"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class OfferFeedbackMetadataV1 extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '0171383190', description: 'ID of the customer.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackMetadataV1.prototype, "customerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '4028546286', description: 'ID of the contract.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackMetadataV1.prototype, "contractId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '448700', description: 'ID of the BPM process.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackMetadataV1.prototype, "bpmProcessId", void 0);
exports.default = OfferFeedbackMetadataV1;
